<template>
  <div v-if="video">
    <div class="wide-screen play-icon" @click="playVideo">
      <img :src="video.thumb_url" class="img-view" data-index="{{ $key }}" alt="" />
    </div>
    <span ref="videoPlay" data-toggle="modal" :data-target="`#video-modal_${video.id}`"></span>

    <div class="modal fade" data-backdrop="static" :id="`video-modal_${video.id}`" aria-hidden="true">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog static modal-lg modal-dialog-centered vertical-align-center">
          <div class="modal-content">
            <div class="modal-body p-0" id="videoPlay">
              <div class="player-container">
                <video-js :id="`my_video_${video.id}`" class="vjs-default-skin vjs-big-play-centered" controls preload="auto" data-setup='{"fluid": true}'>
                  <source :src="video.video_url" type="application/x-mpegURL">
                </video-js>
              </div>
            </div>
            <i class="fa fa-close" data-dismiss="modal" @click="resetModal"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['paramVideo', 'csrf', 'paramUser', 'isUser'],
    data() {
      return {
        video: undefined,
        user: undefined,
        player: undefined
      }
    },
    mounted() {
      this.video = JSON.parse(this.paramVideo)
      if (this.paramUser) this.user = this.paramUser

      let self = this
      this.$nextTick(function() {
        self.player = videojs(`my_video_${self.video.id}`);
      })
    },
    methods: {
      playVideo() {
        if (this.isUser) {
          if (this.video.targets.length > 0) {
            if (this.user) {
              if (this.video.targets.includes('female')) {
                if (this.user.gender != 'female') {
                  centerToastr.fire({
                    html: "女性だけが見ることができる動画です。",
                    icon: 'info'
                  })

                  return;
                }

                if (this.user.female_approved != 1) {
                  centerToastr.fire({
                    html: "マイページから顔写真をアップロードしてください。",
                    icon: 'info'
                  })
                  centerToastr.fire({
                    html: "マイページから顔写真をアップロードしてください。",
                    icon: 'info',
                    showCloseButton: false,
                    showDenyButton: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "マイページへ",
                    cancelButtonText: "キャンセル",
                    confirmButtonColor: "#8F47AD",
                    cancelButtonColor: "#BDBDBD",
                    timer: undefined
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.href = "/mypage/profile";
                    }
                  })

                  return;
                }
              }
            } else {
              centerToastr.fire({
                html: "会員だけが見ることができる動画です。",
                icon: 'info',
                showCloseButton: false,
                showDenyButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "ログインへ",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "#8F47AD",
                cancelButtonColor: "#BDBDBD",
                timer: undefined
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "/login";
                }
              })

              return;
            }
          }
        }
        $('#showLoading').click();
        let self = this
        setTimeout(function() {
          self.$refs.videoPlay.click();
          $('#hideLoading').click();
          self.player.play()
        }, 500)
      },
      resetModal() {
        let self = this
        setTimeout(function() {
          self.player.pause()
        }, 200)
      }
    }
  }
</script>
